import { CopyError } from '../copy/text.js';
import { viewerStrings } from '../copy/strings.js';
import type {
  RelationshipField,
  RelationshipGroupReference,
  RelationshipQueryResult,
} from '@cdr-clarity/contracts';
import { hiddenQueryFields } from './query-references.js';
import { unifiedRecordPage, type UnifiedRecordPage } from './unified-record-page.js';

export type RelationshipDrillDown = (
  reference: RelationshipGroupReference,
) => Promise<RelationshipQueryResult>;

/** Page the original group, retaining its source bindings and denominator context. */
export function relationshipGroupRecords(
  drillDown: RelationshipDrillDown,
  reference: RelationshipGroupReference,
  visible: readonly RelationshipField[],
  cursors: readonly string[] | null,
): Promise<UnifiedRecordPage> {
  const hidden = hiddenQueryFields(reference.query, new Set(visible.map((field) => field.id)));
  if (hidden.length)
    throw new CopyError(
      viewerStrings.webStateRelationshipGroupRecords.theReportUsesFieldsThatAreNow,
    );
  return unifiedRecordPage(
    (query) =>
      drillDown({
        ...reference,
        query: {
          ...reference.query,
          projections: query.projections,
          page: query.page,
          visibleFields: undefined,
        },
      }),
    { ...reference.query, levels: [], measures: [], page: { size: 100 } },
    visible.map((field) => field.id),
    cursors,
  );
}
